import React, { useEffect, useState } from "react";

const styles = `
  .bev-ftr-wrap { background: #222; color: #aaa; font-family: 'Segoe UI', sans-serif; margin-top: 40px; padding: 60px 0 0; }
  .bev-ftr-wrap a { color: #aaa; text-decoration: none; display: block; margin-bottom: 6px; font-size: 0.88rem; transition: color 0.2s; }
  .bev-ftr-wrap a:hover { color: #00C261; }
  .bev-ftr-inner { max-width: 1200px; margin: 0 auto; padding: 0 24px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; }
  .bev-ftr-col h4 { color: #fff; font-size: 1rem; margin-bottom: 18px; }
  .bev-ftr-social { display: flex; gap: 10px; margin-top: 16px; }
  .bev-ftr-social a { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: #fff; color: #222; font-size: 0.85rem; margin: 0; }
  .bev-ftr-social a:hover { background: #00C261; color: #fff; }
  .bev-ftr-copy { background: #1a1a1a; color: #aaa; text-align: center; padding: 16px 24px; margin-top: 40px; font-size: 0.84rem; }
  .bev-ftr-copy a { color: #ccc; text-decoration: none; display: inline; }
  .bev-ftr-copy a:hover { color: #00C261; }
  .bev-ftr-popup { position: relative; cursor: pointer; }
  .bev-ftr-popup p { color: #aaa; font-size: 0.88rem; margin-bottom: 6px; }
  .bev-ftr-popup-content { display: none; background: #333; color: #ccc; font-size: 0.82rem; border-radius: 6px; padding: 10px 12px; margin-bottom: 8px; line-height: 1.5; }
  .bev-ftr-popup:hover .bev-ftr-popup-content { display: block; }
  .bev-ftr-install { cursor: pointer; background: none; border: none; padding: 0; color: #aaa; font-size: 0.88rem; margin-bottom: 6px; text-align: left; transition: color 0.2s; }
  .bev-ftr-install:hover { color: #00C261; }
  @media (max-width: 768px) {
    .bev-ftr-inner { grid-template-columns: 1fr 1fr; }
  }
  @media (max-width: 480px) {
    .bev-ftr-inner { grid-template-columns: 1fr; }
  }
`;

const BevFooter = () => {
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    if (window._bevInstallPrompt) {
      setInstallPrompt(window._bevInstallPrompt);
    }
    const handler = (e) => {
      e.preventDefault();
      window._bevInstallPrompt = e;
      setInstallPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = (e) => {
    e.preventDefault();
    const prompt = installPrompt || window._bevInstallPrompt;
    if (prompt) {
      prompt.prompt();
      prompt.userChoice.then(() => {
        window._bevInstallPrompt = null;
        setInstallPrompt(null);
      });
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="bev-ftr-wrap">
        <div className="bev-ftr-inner">
          <div className="bev-ftr-col">
            <h4>Bevogtet</h4>
            <p style={{ fontSize: "0.88rem", lineHeight: 1.6 }}>Smart Protection Platform delivering reliable Protection Care Solutions for products and services worldwide</p>
            <div className="bev-ftr-social">
              <a href=""><i className="fab fa-twitter"></i></a>
              <a href=""><i className="fab fa-facebook-f"></i></a>
              <a href=""><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>

          <div className="bev-ftr-col">
            <h4>Quick Links</h4>
            <a href="https://bevogtet.com">Company</a>
            <a href="https://bevogtet.com/#whatwedo">What We Do</a>
            <a href="https://bevogtet.com/#features">Features</a>
            <a href="/dashboard/login">Customer Login</a>
            <a href="/dashboard/admin">Customer Admin Login</a>
            <a href="/partner/login">Channel Partner Login</a>
            <a href="/partner/admin">Channel Partner Admin Login</a>
            <button className="bev-ftr-install" onClick={handleInstall}>Download App</button>
          </div>

          <div className="bev-ftr-col">
            <h4>Policy Pages</h4>
            <a href="https://bevogtet.com/cancellation-refund-policy.html">Cancellation &amp; Refund Policy</a>
            <a href="https://bevogtet.com/disclaimer.html">Disclaimer</a>
            <a href="https://bevogtet.com/terms-and-conditions.html">Terms &amp; Conditions</a>
            <a href="https://bevogtet.com/privacy-policy.html">Privacy Policy</a>
            <a href="https://bevogtet.com/faq.html">FAQ</a>
          </div>

          <div className="bev-ftr-col">
            <h4>Corporate Offices</h4>
            <div className="bev-ftr-popup">
              <p>Africa and Middle East</p>
              <div className="bev-ftr-popup-content">Kenya, South Africa, Uganda, Tanzania, Nigeria, Turkey, UAE, Lebanon, Cyprus, Iran and expanding to 5 other Nations soon</div>
            </div>
            <div className="bev-ftr-popup">
              <p>Asia Pacific</p>
              <div className="bev-ftr-popup-content">India, Sri Lanka, Nepal, Bangladesh, Indonesia and expanding to 10 other Nations soon</div>
            </div>
            <div className="bev-ftr-popup">
              <p>Europe</p>
            </div>
            <div className="bev-ftr-popup">
              <p>North &amp; South America</p>
              <div className="bev-ftr-popup-content">Colombia, Venezuela, Brazil, Argentina, Peru and expanding to 5 other Nations soon</div>
            </div>
          </div>
        </div>

        <div className="bev-ftr-copy">
          &copy; <a href="#">Bevogtet</a>, All Right Reserved. Powered by <a href="#">Nupium</a>
        </div>
      </div>
    </>
  );
};

export default BevFooter;
